import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Play = ({
  height = 12,
  width = 12,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 12 12" {...props}>
    <path
      d="M0.879872 1.63274L8.02975 5.80343L0.879872 9.97411V1.63274ZM0.403809 0.803425V10.803L8.97473 5.80298L0.403809 0.802979V0.803425Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.5"
    />
  </SvgIcon>
);
